<template>
  <div class="">
    <Breadcrumbs 
      :children="[
        {
          text: 'Sucursales',
          link: 'companies'
        },
        {
          text: $route.params.id,
        },
        {
          text: 'Ordenes',
        },
      ]"/>

    <div class="card">
      <div class="card-body">
        
        <Loader v-if="loading" />
        <div v-else>

          <div class="row">
            
            <div class="col-sm-8">
              <h5 style="margin-top:0;">
                Ordenes de
                <span class="main-green">{{ company.name }}</span>
              </h5>
            </div>
            <div class="col-sm-4 text-right">
              <button :disabled="orders.length === 0" class="btn main-bg" @click="exportToExcel()">Exportar</button>
            </div>
          </div>

          <!-- Lista de ordenes del sucursal seleccionado -->
          <div style="history-table-container">
            <table class="table" id="orders-table">
              <thead class="thead-light">
                <tr>
                  <th class="text-center">No.</th>
                  <th>Cliente</th>
                  <th>Teléfono</th>
                  <th>Fecha</th>
                  <th class="text-center">Total</th>
                  <th class="text-center">Estado</th>
                  <th class="text-center">Acción</th>
                </tr>
              </thead>
              <tbody v-if="!loading">
                <tr v-for="order in orders" :key="order.id">
                  <td>
                    <div style="font-size: 18px; font-weight: 600;">{{ order.invoice_number }}</div>
                    <div style="font-size: 11px">{{ order.id }}</div>
                  </td>
                  <td>{{ order.client }}</td>
                  <td>{{ order.service_route.point_b.mobile_number }}</td>
                  <td>{{ order.date }}</td>
                  <td class="text-center">{{ order.total }}</td>
                  <td class="text-center" v-html="getStatusLabel(order.status)"></td>
                  <td class="text-center">
                    <div v-if="order.loading">
                      <i class="fa fa-spinner fa-spin"></i>
                    </div>
                    <div v-else>
                      <a
                        title="Ver"
                        @click="showOrderDetails(order)"
                        href="#"
                        class="text-info"
                      >
                        <i class="fa fa-eye"></i>
                      </a>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
            <div v-if="loading" class="text-center">
              <Loader />
            </div>
          </div>

        </div>

      </div>
    </div>  


    <!-- *************** -->
    <!-- MODAL Detalle de orden -->
    <div
      class="modal fade"
      id="detail-modal"
      tabindex="-1"
      role="dialog"
      aria-labelledby="roduct-modal"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content">
          <div class="modal-header detail-modal-header">
            <div class="row" style="width: 100%;">
              <div class="col-sm-10">
                <span style="font-size: large;">
                  <b class="bold">Número de orden: {{ currentOrder.invoice_number }}</b>
                </span>
              </div>
              <div class="col-sm-2">
                <button
                  style="padding: 1rem 0 0 0 !important;"
                  class="close close-modal-custom"
                  @click="closeDetailModal()"
                >
                  <span aria-hidden="true">
                    <i class="fa fa-close"></i>
                  </span>
                </button>
              </div>
            </div>
          </div>
          <div class="modal-body">
            <div v-if="currentOrder.id != ''">

              <OrderDetailModalContent
                :key="currentOrder.id"
                :currentOrder="currentOrder"
                :orderProducts="orderProducts"/>

            </div>
          </div>
          <div class="modal-footer">
            <div class="row" style="width:100%">
              <div class="col-sm-4">
                <button
                  :disabled="loading || currentOrder.status == $constants.orderStatus.CANCELED || currentOrder.status == $constants.orderStatus.ARRAIVED"
                  @click="cancelOrder"
                  class="btn btn-danger"
                >Cancelar
                </button>
                <Loader v-if="cancelOrder.loading"/>
              </div>
              <div class="col-sm-8 text-right">

                <button
                  :disabled="loading"
                  @click="closeDetailModal()"
                  class="btn btn-secundary"
                >Cerrar
                </button>
                <button
                  :disabled="loading || currentOrder.status == $constants.orderStatus.ARRAIVED"
                  @click="updateOrderStatus()"
                  class="btn main-bg ml-2"
                >Actualizar estado
                </button>

                <UpdateOrderStatusBtn 
                :order_id="currentOrder.id" 
                :user_id="currentOrder.userId" 
                :branch_office_id="currentOrder.branchOfficeId" 
                v-on:status-updated="onOrderStatusUpdate" />

              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- *************** -->

  </div>  
</template>
<script>
import { BranchOfficeService } from '../../services/BranchOfficeService';
import { CompanyService } from '../../services/CompanyService';
import Loader from '../components/Loader';
import OrderDetailModalContent from "../components/OrderDetailModalContent";
import Breadcrumbs from "../components/Breadcrumbs";
import UpdateOrderStatusBtn from '../components/UpdateOrderStatusBtn.vue';

export default {
  name: 'CompanyOrders',
  components: { 
    Loader,
    OrderDetailModalContent,
    Breadcrumbs,
    UpdateOrderStatusBtn
   },
  data:function(){
    return {
      ordersOnPage: [],
      loading: false,
      company: {
        name: ''
      },
      filterForselectedBranchOfficeOrders: '',
      orders: [],
      branchOfficeService: new BranchOfficeService(),
      companyService: new CompanyService(),
      paginationData: {
        currentPage: 1,
        totalOrders: 0,
        itemsPerPage: 10,
      },
      currentOrder: {
        id: "",
        name: "",
        phone: "",
        address: "",
        province: "",
        subTotal: 0,
        taxes: 0,
        total: 0,
        status: "",
        payment_type: "",
        transaction_id: "",
        payment_provider: "",
        number: "",
        userId: "",
        companyId: "",
        service_route: {
          point_a: {},
          point_b: {},
        },
        invoice_info: {}
      },
      orderProducts: [],
      cancelReasons: [
        "El cliente canceló",
        "No hay stock",
        "Error de creación",
      ],
    };
  },
  methods: {
    onOrderStatusUpdate({status, order_id}){
      this.orders.find(x => x.id === order_id).status = status;
    },
    exportToExcel() {
      const getStatus = (number) => {
        let label = number;
        switch (parseInt(number)) {
          case this.$constants.orderStatus.IN_REPART:
            label = "En reparto";
            break;
          case this.$constants.orderStatus.SHIPPED:
            label = "Enviada";
            break;
          case this.$constants.orderStatus.ARRAIVED:
            label = "Entregado";
            break;
          case this.$constants.orderStatus.CANCELED:
            label = "Cancelada";
            break;
        }
        return label;
      };
      const data = [];
      this.orders.forEach((o) => {
        data.push([
          o.invoice_number || '',
          o.client || 'N/A',
          this.company.name || 'N/A',
          getStatus(o.status),
          o.date || 'N/A',
          o.total || 0,
        ]);
      });

      data.unshift([
        "Numero",
        "Cliente",
        "Sucursal",
        "Estado",
        "Fecha",
        "Total",
      ]);
      this.$helpers.exportToCsv("HistorialDeOrdenes.csv", data);
    },
    getStatusLabel(status){
      return this.branchOfficeService.getStatusLabel(status);
    },
    async cancelOrder(){
      this.currentOrder.loading = true;

      let reason = await Swal.fire({
        title: "Seleccione la razon de cancelacion",
        input: "select",
        inputOptions: this.cancelReasons,
        showCancelButton: true,
        confirmButtonColor: "#4279AF",
        cancelButtonColor: "#d33",
        cancelButtonText: '<i class="fa fa-close"></i> Cerrar',
        confirmButtonText: '<i class="fa fa-check"></i> Aceptar',
        backdrop: false,
        reverseButtons: true,
      });
      if (reason && reason.value) {
        reason = this.cancelReasons[reason.value];
        this.updatingOrderStatus = true;
        
        const res = await this.branchOfficeService.cancelOrder(
          this.$route.params.id,
          this.currentOrder.id,
          reason
        );

        if(res.ok){
  
          this.updatingOrderStatus = false;
          this.$helpers.toast("Orden cancelada!");
  
          this.currentOrder.status = this.$constants.orderStatus.CANCELED;
          this.orders.forEach((o) => {
            if (o.id === this.currentOrder.id){
              o.status = this.$constants.orderStatus.CANCELED;
            }
          });
  
          this.closeDetailModal();

        }else{
          this.$helpers.message('Error', res.message, 'error');
        }

      }
      this.currentOrder.loading = false;
    },
    closeDetailModal: function () {
      $("#detail-modal").modal("hide");
    },
    getStatus(status) {
      return this.branchOfficeService.getStatusLabel(status);
    },
    deleteOrder(order) {
      console.log("deleteOrder ", order);
    },
    async showOrderDetails(order) {
      order.loading = true;
      this.orderProducts = [];

      try {
        const result = await this.branchOfficeService.getOrderDetail(
          this.$route.params.id,
          order.id
        );

        if(result.ok){
          this.orderProducts = result.cart;
          this.currentOrder = Object.assign({}, result.orderData);
          $("#detail-modal").modal("show");
        }else{
          throw new Error(result.message);
        }
      } catch (e) {
        console.log("ERROR showOrderDetails ", e);
        this.$helpers.toast("Error al generar detalle", "error");
      } finally {
        order.loading = false;
        this.onRequest = false;
      }
    },    
  },
  beforeMount: async function() {
    this.loading = true;
    const res = await this.companyService.getCompanyData(this.$route.params.id);
    if(res.ok){
      this.company = res.data;
    }else{
      this.$helpers.message('Error', res.message, 'error');
    }
    const ordersResponse = await this.branchOfficeService.getBranchOfficeOrders(this.$route.params.id);
    if(ordersResponse.ok){
      this.orders = ordersResponse.data;
      
    }else{
      this.$helpers.message('Error', ordersResponse.message, 'error');
    }
    this.loading = false;

    this.$nextTick(function(){
      jQuery(function(){
        $('#orders-table').DataTable({
          scrollY:        '45vh',
          scrollCollapse: true,
        });
      });      
    });
  }
}
</script>
<style scoped>
th,td{
  font-weight: 400;
}

</style>